/* eslint-disable jsx-a11y/no-access-key */
import React, { useContext, useEffect, useRef, useState } from 'react'
import style from '../style.module.sass'
import MainPageWrapper from '../../Main-page-wrapper'
import Footer from '../../Footer/Footer'
import { FormControl, Input, useTheme } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import GeneratorResult from './components/GeneratorResult'
import { useSelector } from 'react-redux'
import {
  generateBList,
  handleAISelectionNavigation,
  isObjectEmpty,
  textClear
} from '../../../utils'
import comBotWhite from '../../../assets/combot-white.svg'
import { useActions } from '../../../utils/action-helper'
import { userGetAllBenchmarks, userGetTaskTypes } from '../../../actions'
import TLServiceComponent from '../../../contexts/TLServiceComponent'
import config from '../../../config'
import RightSection from './components/RightSection'
import RoboSpinner from '../../RoboSpinner'
import ErrorModal from '../ModalWindows/ErrorModal'
import { cancelClick, checkTick, runOurAi } from '../../../utils/ai'

const TextGenerator = () => {
  const { theme: { colors, bgColors, borderColors } } = useTheme()
  const { t } = useTranslation()
  const tlService = useContext(TLServiceComponent)

  const token = useSelector(state => state.userData.token)
  const benchmarks = useSelector(state => state.userData.benchmarks)
  const taskTypes = useSelector(state => state.userData.taskTypes)
  const themeState = useSelector(state => state.userData.theme)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const useBenchmark = useSelector(state => state.analyseData.useBenchmark)
  const aiMaxTextSize = useSelector((state) => state.userData.user.ai_settings?.max_text_size || {})

  const {
    actionUserGetAllBenchmarks,
    actionUserGetTaskTypes
  } = useActions({
    actionUserGetAllBenchmarks: userGetAllBenchmarks(tlService),
    actionUserGetTaskTypes: userGetTaskTypes(tlService)
  })

  const [message, setMessage] = useState('')
  const [resultMode, setResultMode] = useState(false)
  const [enabledSubmit, setEnabledSubmit] = useState(false)
  const [missingTextType, setMissingTextType] = useState(false)
  const [promptValues, setPromptValues] = useState({})
  const benchmarkSelectWrapperRef = useRef(null)

  const [submitted, setSubmitted] = useState(false)
  const [benchmarkList, setBenchmarkList] = useState([])
  const [useBenchmarkList, setUseBenchmarkList] = useState(-1)
  const [currentCard, setCurrentCard] = useState({})
  const [translatedText, setTranslatedText] = useState('')
  const [shouldAnalyse, setShouldAnalyse] = useState(false)
  const [error, setError] = useState(null)
  const [percent, setPercent] = useState(0)
  const [promptForOptimization, setPromptForOptimization] = useState('')
  const [newPromptOpen, setNewPromptOpen] = useState(false)
  const taskIdRef = useRef(0)

  useEffect(() => {
    if (!taskTypes?.length) {
      actionUserGetTaskTypes(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // create a benchmark list
  useEffect(() => {

    // filter by type
    const filteredTaskTypes = taskTypes.filter(el => el?.function === 'TextGenerator')

    // if benchmark and taskTypes loaded
    if (!isObjectEmpty(filteredTaskTypes) && !isObjectEmpty(benchmarks)) {
      const [selectedBList, bList] = generateBList(filteredTaskTypes, benchmarks, useBenchmark, 'textGenerator')

      if (bList?.length) {
        const matchedSetting = filteredTaskTypes.find(setting => setting.id === bList[selectedBList].typeId)

        setCurrentCard(matchedSetting)
      } else {
        setCurrentCard({})
      }
      // set selected position in benchmark list
      setUseBenchmarkList(selectedBList)
      setBenchmarkList(Array.from(bList))

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benchmarks, taskTypes])

  useEffect(() => {
    if (isObjectEmpty(benchmarks)) {
      actionUserGetAllBenchmarks(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!message.length > 0 || useBenchmarkList === -1) {
      setEnabledSubmit(false)
    } else {
      setEnabledSubmit(true)
      setMissingTextType(false)
    }
  }, [message, useBenchmarkList])

  useEffect(() => {
    if (useBenchmarkList > -1 && Array.isArray(currentCard?.shared_settings?.optimization?.settings)) {
      setPromptValues(currentCard?.shared_settings?.optimization?.settings.reduce((acc, setting) => ({
        ...acc,
        [setting.name]: setting.default
      }), {}))
    }
  }, [useBenchmarkList])

  useEffect(() => {
    document.addEventListener('keydown', e => handleAISelectionNavigation(e,
      null, benchmarkSelectWrapperRef, config.accessKeys.aiBenchmarkSelection, null))
    return () => document.removeEventListener('keydown', e => handleAISelectionNavigation(e, null, benchmarkSelectWrapperRef, config.accessKeys.aiBenchmarkSelection, null))
  }, [])

  const handleMessageChange = (event) => {
    setMessage(event.target.value)
  }

  const handleSwitchToResult = () => {
    if (enabledSubmit) {
      setResultMode(true)
    } else {
      setMissingTextType(true)
    }
  }

  const doneTick = (res) => {
    setTranslatedText(res)
    setShouldAnalyse(true)
    setPromptValues({})
  }
  const errorTick = (error) => {
    setPromptForOptimization('')
    setPromptValues({})
    setSubmitted(false)
    setError(error)
  }

  const handleOurAi = async (textOriginal, optimization) => {

    setSubmitted(true)
    setError(null)
    const text = textClear(textOriginal)

    const selectedBenchmark = benchmarkList[useBenchmarkList]?.id
    let localTextLanguage
    if (selectedBenchmark) {
      localTextLanguage = benchmarks[selectedBenchmark]?.locale_name
    } else {
      return false
    }

    const [taskId, error] = await runOurAi(
      tlService,
      text,
      token,
      promptValues,
      promptForOptimization,
      benchmarkList,
      useBenchmarkList,
      aiMaxTextSize,
      'Assistant',
      localTextLanguage,
      optimization)

    if (taskId > 0) {
      taskIdRef.current = taskId
      // set tick
      setTimeout(() => checkTick(t, tlService, taskIdRef, token, setPercent, true, doneTick, errorTick), 1000)
      return true
    }
    setError({ text: t(error.text), header: t(error.header) })
    setPercent(0)
    setSubmitted(false)
    return false
  }

  const handleCancelClick = async () => {
    await cancelClick(t, tlService, taskIdRef, token, setPercent, setError)
    setPercent(0)
    setSubmitted(false)
  }

  const handleTextTypeChange = e => {
    const newId = parseInt(e.target.value.toString())
    setUseBenchmarkList(newId)
    setMissingTextType(false)

    // filter by type
    const filteredTaskTypes = taskTypes.filter(el => el?.function === 'TextGenerator')
    const matchedSetting = filteredTaskTypes.find(setting => setting.id === benchmarkList[newId].typeId)
    setCurrentCard(matchedSetting)
  }

  if (isObjectEmpty(currentCard)) {
    return (
      <MainPageWrapper>
        <h1 style={{ color: colors.colorStatusError, position: 'absolute', top: '50%', left: '50%' }}>
          {t('ai_gen_no-data')}
        </h1>
      </MainPageWrapper>
    )
  }
  return (
    <MainPageWrapper>
      <section className={`${style.mainCont} mt-5`} tabIndex={-1}
               style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflowY: 'hidden' }}>


        {missingTextType && (<div className="d-flex flex-column align-items-center mt-1"><p
          style={{ color: colors.colorStatusError }}>{t('ai_gen_missing_text_type')}</p></div>)}
        <div className="container-fluid" style={{ overflowX: 'hidden', padding: '0 1rem' }}>
          {submitted && <RoboSpinner cancelButton={true} handleCancelClick={handleCancelClick} spinnerProgress={percent}
                                     text={t('ai_gen_spinner-text')}/>}
          <ErrorModal error={error} setError={setError}/>

          {
            resultMode ? (
              <GeneratorResult
                handleOurAi={handleOurAi}
                message={message}
                analyseButtonEnable={enabledSubmit}
                setAnalyseButtonEnable={setEnabledSubmit}
                initialPromptValues={promptValues}
                benchmarkSelectWrapperRef={benchmarkSelectWrapperRef}
                benchmarkList={benchmarkList}
                useBenchmarkList={useBenchmarkList}
                setUseBenchmarkList={setUseBenchmarkList}
                currentCard={currentCard}
                setCurrentCard={setCurrentCard}
                setMissingTextType={setMissingTextType}
                handleTextTypeChange={handleTextTypeChange}
                translatedText={translatedText}
                setTranslatedText={setTranslatedText}
                shouldAnalyse={shouldAnalyse}
                setShouldAnalyse={setShouldAnalyse}
                setError={setError}
                setSubmitted={setSubmitted}
                promptForOptimization={promptForOptimization}
                setPromptForOptimization={setPromptForOptimization}
                setPromptValues={setPromptValues}
                newPromptOpen={newPromptOpen}
                setNewPromptOpen={setNewPromptOpen}
                promptValues={promptValues}
              />
            ) : (
              <>
                <div className="row d-flex flex-lg-row p-3 pt-5 mt-1 mb-1" style={{
                  height: '80vh',
                  borderRadius: '10px',
                  backgroundColor: bgColors.bgPrimary0,
                  boxShadow: '0 0 5px rgba(0, 0, 0, 0.161)'
                }}>
                  {/* Left Section */}
                  <div className="col-lg-8 mb-4 mb-lg-0 d-flex flex-column" style={{ height: '100%' }}>
                    <div className=" p-3 d-flex flex-column justify-content-between" style={{
                      height: '100%', borderRadius: '8px',
                      border: `1px solid ${borderColors.borderPrimary200}`
                    }}>
                      <div>
                        <div style={{ height: 40 }}></div>
                        <h5 className="fw-bold" style={{ color: colors.colorText }}>{t('ai_gen_prompt_title')}</h5>
                        <p className="small mb-3"
                           style={{ color: colors.colorMutedText }}>{t('ai_gen_prompt_description')}</p>
                      </div>
                      <hr style={{ borderColor: borderColors.borderPrimary200, margin: '12px 0' }}/>
                      <FormControl fullWidth style={{
                        flex: 1,
                        borderBottom: `1px solid ${borderColors.borderPrimary200}`,
                        overflow: 'hidden'
                      }}>
                        <Input
                          placeholder={t('ai_gen_type-your-message')}
                          multiline
                          rows={15}
                          onChange={handleMessageChange}
                          value={message}
                          disableUnderline
                          inputProps={{
                            accessKey: config.accessKeys.editor,
                            tabIndex: config.tabIndexes.genInputField,
                            style: {
                              color: colors.colorText,
                            }
                          }}/>
                      </FormControl>
                      <div
                        onClick={handleSwitchToResult}
                        tabIndex={config.tabIndexes.genButton}
                        style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <button className="btn d-flex align-items-center justify-content-center"
                                title={t('ai_gen_start_button')} style={{
                          backgroundColor: bgColors.bgProgress100,
                          color: colors.colorBtnText,
                          border: isContrast ? `1px solid ${borderColors.borderPrimary200}` : 'none'
                        }} onClick={handleSwitchToResult} accessKey={config.accessKeys.runAnalyse}>
                          <img style={{ marginRight: 4 }} src={comBotWhite} alt="" width="30px"/>
                          {t('ai_gen_initial_gen_button')}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Right Section */}
                  <RightSection
                    benchmarkSelectWrapperRef={benchmarkSelectWrapperRef}
                    benchmarkList={benchmarkList}
                    useBenchmarkList={useBenchmarkList}
                    currentCard={currentCard}
                    handleTextTypeChange={handleTextTypeChange}
                    promptForOptimization={promptForOptimization}
                    setPromptForOptimization={setPromptForOptimization}
                    setPromptValues={setPromptValues}
                    promptValues={promptValues}
                    handleOurAi={handleOurAi}
                  />
                </div>
              </>
            )
          }
        </div>
        <div style={{ flex: '1' }}>
          <Footer/>
        </div>
      </section>
    </MainPageWrapper>
  )
}

export default TextGenerator
